module.exports = __webpack_public_path__ + "static/media/night01.8665e2b6.jpeg";